import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

import PhoneTips from "presentation/pages/persons/elements/phone-tips";

import RemoveAction from "presentation/components/remove-action";
import AddButton from "presentation/components/buttons/add";

import { phoneTypes } from 'presentation/model/constants';

import {
    changePhonesList,
    handleChangePhones,
    phonesFormValue,
    mountItems
} from 'presentation/pages/persons/functions/phones';

class PhoneTabStudentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            componentFlags: []
        };
    }

    addOption = () => {
        let { component } = this.props;
        let { totalPhoneItems } = component.state;
        component.setState({ ...component.state, totalPhoneItems: totalPhoneItems + 1 }, () => mountItems(component));
    }

    removeAction = (key) => {
        let { component } = this.props;

        let { totalPhoneItems } = component.state;

        let data = changePhonesList(component, { key: key }, true);

        //reorganiza as keys
        let index = 0;
        data.map((element, i) => {
            if (!element.isDeleteRequested) {
                element.key = index + 1;
                index++;
            }
            return element;
        });

        component.setState({ ...component.state, totalPhoneItems: totalPhoneItems - 1, phones: data }, () => mountItems(component));
    }


    render() {

        const { phones, loading, totalPhoneItems, component } = this.props;

        const { addOption, removeAction } = this;

        const validPhones = phones.filter(x => !x.isDeleteRequested);
        
        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Telefones do aluno</h4>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <table className="table table-borderless">
                            <thead>
                                <tr>
                                    <th width="20%">Tipo</th>
                                    <th width="50%">Número</th>
                                    <th className="text-end" width="30%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {validPhones.map((element, index) => {
                                    let key = element.key;

                                    let phoneTypeValue = phonesFormValue(key, 'phoneType', component);
                                    let phoneNumberValue = phonesFormValue(key, 'phoneNumber', component);
                                    
                                    const deleteIsDisabled = totalPhoneItems < 2;
                                    return (
                                        <tr key={`phone-${key}`}>
                                            <td>
                                                <Form.Select
                                                    aria-label="Tipo de telefone"
                                                    defaultValue={phoneTypeValue}
                                                    id={`phoneType-${key}`}
                                                    name={`phoneType-${key}`}
                                                    data-field-name="phoneType"
                                                    onChange={(e) => handleChangePhones(key, e, component)}
                                                    required
                                                >
                                                    <option key="-1">Selecione</option>
                                                    {phoneTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                                </Form.Select>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    id={`phoneNumber-${key}`}
                                                    name={`phoneNumber-${key}`}
                                                    data-field-name="phoneNumber"
                                                    defaultValue={phoneNumberValue || ""}
                                                    onChange={(event) => handleChangePhones(key, event, component)}
                                                />
                                            </td>
                                            <td>
                                                <RemoveAction
                                                    className="float-end"
                                                    component={this}
                                                    optionKey={key}
                                                    loading={loading}
                                                    deleteIsDisabled={deleteIsDisabled}
                                                    removeAction={removeAction} />
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr>
                                    <td colSpan={3}>
                                        <div className="text-end">
                                            <AddButton
                                                containerProps={{
                                                    onClick: addOption,
                                                    variant: 'success',
                                                    className: 'mt-1 mb-1'

                                                }}
                                                title='Adicionar telefone'
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <PhoneTips component={this} />
                    </Col>
                </Row>
            </Container>
        );
    };
}

export default PhoneTabStudentForm;